import { createRouter, createWebHistory } from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import store from '../store/index'

// 首屏需要的组件直接导入
import Home from '../views/Home.vue'

// 使用动态导入替代直接导入，以便代码分割
const DataProducts = () => import(/* webpackChunkName: "news" */ '../views/DataProducts.vue')
const EnterProducts = () => import(/* webpackChunkName: "news" */ '../views/EnterProducts.vue')
const EndProduct = () => import(/* webpackChunkName: "news" */ '../views/EndProduct.vue')
const Media = () => import(/* webpackChunkName: "media" */ '../views/Media.vue')
const New = () => import(/* webpackChunkName: "news" */ '../views/New.vue')
const News = () => import(/* webpackChunkName: "news" */ '../views/News.vue')
const ServiceCentre = () => import(/* webpackChunkName: "product" */ '../views/ServiceCentre.vue')
const Login = () => import(/* webpackChunkName: "user" */ '../views/Login.vue')
const Register = () => import(/* webpackChunkName: "user" */ '../views/Register.vue')
const Server = () => import(/* webpackChunkName: "server" */ '../views/server.vue')
const Detail = () => import(/* webpackChunkName: "product-detail" */ '../views/Detail.vue')
const Order = () => import(/* webpackChunkName: "order" */ '../views/order.vue')
const Pay = () => import(/* webpackChunkName: "payment" */ '../views/pay.vue')
const WxScan = () => import(/* webpackChunkName: "payment" */ '../views/pay/wxscan.vue')
const Introduction = () => import(/* webpackChunkName: "about" */ '../views/introduction.vue')
const Recruit = () => import(/* webpackChunkName: "about" */ '../views/recruit.vue')
const Notify = () => import(/* webpackChunkName: "payment" */ '../views/pay/pay_notify.vue')
const SearchGoods = () => import(/* webpackChunkName: "search" */ '../views/searchgoods.vue')
const SearchShop = () => import(/* webpackChunkName: "search" */ '../views/searchshop.vue')
const ManageOrder = () => import(/* webpackChunkName: "order" */ '../views/order_manager.vue')
const ShopCar = () => import(/* webpackChunkName: "shop" */ '../views/shopcar.vue')
const Resetpwd = () => import(/* webpackChunkName: "user" */ '../views/resetpwd.vue')
const Center = () => import(/* webpackChunkName: "user" */ '../views/center.vue')
const Contact = () => import(/* webpackChunkName: "about" */ '../views/contact.vue')
const MerchantCenter = () => import(/* webpackChunkName: "merchant" */ '../views/merchantcenter/merchantcenter.vue')
const Settle = () => import(/* webpackChunkName: "merchant" */ '../views/merchantcenter/settle.vue')
const Review = () => import(/* webpackChunkName: "merchant" */ '../views/merchantcenter/review.vue')
const GoodsEdit = () => import(/* webpackChunkName: "merchant" */ '../views/merchantcenter/GoodsEdit.vue')
const ShopDetail = () => import(/* webpackChunkName: "shop" */ '../views/shopdetail.vue')
/**
 * 异步加载产品详情组件（使用webpack代码分割，生成独立chunk文件"product-detail"）
 * @returns {Promise<Component>} 返回解析后的Vue组件
 */
const ProductDetail = () => import(/* webpackChunkName: "product-detail" */ '../views/ProductDetail.vue')
const Industry = () => import('../views/industry.vue')
const Plans = () => import('../views/plans.vue')
const PlanDetail = () => import('../views/planDetail.vue')
const Solution = () => import('../views/solution.vue')

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      title: '九任智造',
      preload: true // 标记需要预加载的路由
    }
  },
  {
    path: '/media',
    name: 'media',
    component: Media,
    meta: {
      title: '九任智造-视频媒体',
    }
  },
  {
    path: '/DataProducts',
    name: 'DataProducts',
    component: DataProducts,
    meta: {
      title: '九任智造 - 数据中心产品',
    }
  },
  {
    path: '/EnterProducts',
    name: 'EnterProducts',
    component: EnterProducts,
    meta: {
      title: '九任智造 - 企业产品',
    }
  },
  {
    path: '/EndProduct',
    name: 'EndProduct',
    component: EndProduct,
    meta: {
      title: '九任智造 - 终端产品',
    }
  },
  {
    path: '/news',
    name: 'news',
    component: News,
    meta: {
      title: '九任智造 - 新闻资讯'
    }
  },
  {
    path: '/news/:id',
    name: 'new',
    component: New,
    meta: {
      title: '九任智造 - 新闻详情'
    }
  },
  {
    path: '/aiService',
    name: 'aiService',
    component: Server,
    meta: {
      title: '九任智造 - AI服务',
    }
  },
  {
    path: '/ServiceCentre',
    name: 'ServiceCentre',
    component: ServiceCentre,
    meta: {
      title: '九任智造 - 服务中心',
    }
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      title: '九任智造 - 登录'
    }
  },
  {
    path: '/register',
    name: 'register',
    component: Register,
    meta: {
      title: '九任智造 - 注册'
    }
  },
  {
    path: '/detail/:id',
    name: 'detail',
    component: Detail,
    meta: {
      title: '九任智造 - 商品'
    }
  },
  {
    path: '/order',
    name: 'order',
    component: Order,
    meta: {
      title: '九任智造 - 订单'
    },
    props: true
  },
  {
    path: '/pay',
    name: 'pay',
    component: Pay,
    meta: {
      title: '九任智造 - 支付'
    }
  },
  {
    path: '/pay/wxscan',
    name: 'WxScan',
    component: WxScan,
    meta: {
      title: '九任智造 - 微信支付'
    }
  },
  {
    path: '/introduction',
    name: 'introduction',
    component: Introduction,
    meta: {
      title: '九任智造 - 公司介绍'
    }
  },
  {
    path: '/recruit',
    name: 'recruit',
    component: Recruit,
    meta: {
      title: '九任智造 - 招贤纳士'
    }
  },
  {
    path: '/pay/notify',
    name: 'notify',
    component: Notify,
    meta: {
      title: '九任智造 - 支付通知'
    }
  },
  {
    path: '/mall/search/goods',
    name: 'searchgoods',
    component: SearchGoods,
    meta: {
      title: '九任智造 - 搜索商品',
    }
  },
  {
    path: '/mall/search/shop',
    name: 'searchshop',
    component: SearchShop,
    meta: {
      title: '九任智造 - 搜索店铺'
    }
  },
  {
    path: '/manager/order',
    name: 'manageorder',
    component: ManageOrder,
    meta: {
      title: '九任智造 - 订单管理'
    }
  },
  {
    path: '/shop/',
    name: 'shopcar',
    component: ShopCar,
    meta: {
      title: '九任智造 - 购物车'
    }
  },
  {
    path: '/resetpwd',
    name: 'resetpwd',
    component: Resetpwd,
    meta: {
      title: '九任智造 - 找回密码'
    }
  },
  {
    path: '/center',
    name: 'center',
    component: Center,
    meta: {
      title: '九任智造 - 个人中心'
    }
  },
  {
    path: '/contact',
    name: 'contact',
    component: Contact,
    meta: {
      title: '九任智造 - 联系我们'
    }
  },
  {
    path: '/merchantcenter',
    name: 'merchantcenter',
    component: MerchantCenter,
    meta: {
      title: '九任智造 - 商家中心'
    }
  },
  {
    path: '/merchantcenter/settle',
    name: 'settle',
    component: Settle,
    meta: {
      title: '九任智造 - 商家入驻'
    }
  },
  {
    path: '/merchantcenter/settle/review',
    name: 'review',
    component: Review,
    meta: {
      title: '九任智造 - 入驻审核中'
    }
  },
  {
    path: '/merchantcenter/goodsedit/:id',
    name: 'goodsedit',
    component: GoodsEdit,
    meta: {
      title: '九任智造 - 编辑商品'
    }
  },
  {
    path: '/shop/:id',
    name: 'shopdetail',
    component: ShopDetail,
    meta: {
      title: '九任智造 - 店铺详情'
    }
  },
  {
    path: '/industry',
    name: 'industry',
    component: Industry,
    meta: {
      title: '九任智造 - 行业应用'
    }
  },
  {
    path: '/industry/plans/:id',
    name: 'plans',
    component: Plans,
  },
  {
    path: '/plans/detail/:id',
    name: 'planDetail',
    component: PlanDetail,
  },
  {
    path: '/solution/:id',
    name: 'solution',
    component: Solution,
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      // 如果存在保存的位置，直接返回
      return savedPosition
    } else if (to.hash) {
      // 如果有hash，滚动到锚点
      return { el: to.hash, behavior: 'smooth' }
    } else {
      // 否则滚动到顶部
      return { top: 0, behavior: 'smooth' }
    }
  }
})

// 添加加载进度条
NProgress.configure({ 
  showSpinner: false,   // 不显示加载微调器
  easing: 'ease',       // CSS3缓动
  speed: 500,           // 进度条的速度
  trickleSpeed: 200,    // 自动递增间隔
  minimum: 0.1,         // 最小百分比
});

router.beforeEach((to, from, next) => {
  // 开始加载进度条
  NProgress.start()
  next()
})

router.afterEach((to, from) => {
  // 设置页面标题
  document.title = to.meta.title || '九任智造'
  
  // 完成加载进度条
  NProgress.done()
  
  // 滚动控制由scrollBehavior处理
})

export default router
